export default __webpack_public_path__ + "static/media/Voldemort's Wand - Img - Wip 2_01.d5b36c25.jpg";